import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext({ company: {}, contact: {}, social: {}, settings: {}, loading: true });

export function SiteProvider({ children }) {
  const [data, setData] = useState({ company: {}, contact: {}, social: {}, settings: {}, loading: true });

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.get("/public/company").then((r) => r.data).catch(() => ({})),
      api.get("/public/contact-info").then((r) => r.data).catch(() => ({})),
      api.get("/public/social-links").then((r) => r.data).catch(() => ({})),
      api.get("/public/site-settings").then((r) => r.data).catch(() => ({})),
    ]).then(([company, contact, social, settings]) => {
      if (mounted) setData({ company, contact, social, settings, loading: false });
    });
    return () => {
      mounted = false;
    };
  }, []);

  return <SiteContext.Provider value={data}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}
